export class CallRecordTableColumns {
    constructor(
        public id: number,
        public employeeName: string,
        public employeeEmail: string,
        public employeeImage: string,
        public requesterDataName: string,
        public requesterDataEmail: string,
        public requesterDataImage: string,
        public clientId: number,
        public clientName: string,
        public serviceId: number,
        public serviceName: string,
        public serviceSectionId: number,
        public status: string,
        public createdAt: string,
        public mobilePhoneNumber : string,
        public containingSms :boolean,
        public code:string,
        public notificationStatus: string

    ) {}
}
